import { render, staticRenderFns } from "./AdvertisementsTable.vue?vue&type=template&id=97734c64&"
import script from "./AdvertisementsTable.vue?vue&type=script&lang=js&"
export * from "./AdvertisementsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports